import React from 'react'
import styled from '@emotion/styled/macro'

const ShieldContainer = styled('div')`
    border-radius: 0 0 50% 50%;
    min-height: 0.25rem;
    min-width: 0.75rem;
    height: ${({ height = '80%' }) => height} !important;
    width: ${({ width = '80%' }) => width};
    align-self: center;
    border: var(--borders-main);
    position: relative;
    background: linear-gradient(
        90deg,
        ${({
            primaryColor = 'var(--colors-grays-0)',
            secondaryColor = 'var(--colors-grays-20)',
        }) =>
            `${primaryColor}, ${primaryColor} 50%, ${secondaryColor} 50%, ${secondaryColor}`}
    );
    overflow: hidden;
    grid-row: 1 / span 3;
    grid-column: span 1;
    box-shadow: 0.125rem 0.25rem var(--colors-primary-lighter);
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    h6 {
        margin: 0;
        text-align: center;
        padding: 0.25em;
        align-self: center;
        border-bottom: var(--borders-main);
        background: var(--colors-primary-accent);
        box-sizing: border-box;
        width: 100%;
        position: absolute;
    }
`
const Shield = ({
    name,
    primaryColor,
    secondaryColor,
    colors,
    style,
    width,
    height,
    onClick,
    className,
}) => {
    return (
        <ShieldContainer
            {...{
                name,
                primaryColor: primaryColor || colors?.[0],
                secondaryColor: secondaryColor || colors?.[1],
                style,
                height,
                width,
                className,
                onClick,
            }}
        >
            {name && <h6>{name}</h6>}
        </ShieldContainer>
    )
}

export default Shield
